/** Base query key for the overheads list. Combine with filters for the full key. */
export const OVERHEADS_QUERY_KEY = 'overheads';

/** Base query key for the overheads summary cards. */
export const OVERHEADS_SUMMARY_QUERY_KEY = 'overheads-summary';

/**
 * Overheads only change through in-app mutations, and every mutation
 * invalidates these queries — so re-mounts / window refocus within this window
 * can serve the cache instead of hitting the backend again.
 */
export const OVERHEADS_STALE_TIME = 5 * 60 * 1000;
